import { render, staticRenderFns } from "./RejectedOldAqs.vue?vue&type=template&id=e684ccf2"
import script from "./RejectedOldAqs.vue?vue&type=script&lang=js"
export * from "./RejectedOldAqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports